import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useApi, useUser } from "../../../context/api.js";
import { setMilestoneValidation, useHomework } from "../../../context/homework";
import MDTypography from "../../../components/MDTypography";

import ParentValidationStudent from "./modes/parent/student.js";
import ParentValidationParent from "./modes/parent/parent.js";
import ManualValidationStudent from "./modes/manual/student.js";
import ManualValidationParent from "./modes/manual/parent.js";
import AutonomousValidationParent from "./modes/autonomous/parent.js";
import AutonomousValidationStudent from "./modes/autonomous/student.js";
import ActivityValidationParent from "./modes/activity/parent.js";
import ActivityValidationStudent from "./modes/activity/student.js";
import { formatDate } from "../../../utils/date.js";
import AlreadyValidated from "./already-validated.js";
import { useMilestone } from "../../../context/homework/homework-selectors.js";

const VALIDATION_MODES = {
  parent: {
    student: ParentValidationStudent,
    parent: ParentValidationParent,
  },
  manual: {
    student: ManualValidationStudent,
    parent: ManualValidationParent,
  },
  autonomous: {
    student: AutonomousValidationStudent,
    parent: AutonomousValidationParent,
  },
  activity: {
    student: ActivityValidationStudent,
    parent: ActivityValidationParent,
  },
};

function MilestoneValidationDialog() {
  const [homework, dispatch] = useHomework();
  const user = useUser();
  const m = useMilestone(homework.milestoneValidation, homework.milestoneValidationFrom);

  const onCancel = () => setMilestoneValidation(dispatch, null, homework.milestoneValidationFrom);

  const ValidationComponent =
    (m &&
      m.id &&
      VALIDATION_MODES[m.validation_mode][
        homework.milestoneValidationFrom && ["admin", "parent"].includes(user.type)
          ? "parent"
          : "student"
      ]) ||
    (() => null);

  const title = m && (
    <>
      <MDTypography variant="h5" component="div">
        {[m.homework.name, m.description].filter((x) => !!x).join(" - ")}
      </MDTypography>
      <MDTypography
        sx={{
          mb: 1.5,
          fontStyle: "italic",
          fontSize: 12,
          color: new Date(m.homework.list.end + "T23:59:59") <= new Date() ? "red" : undefined,
        }}
        color="text"
      >
        Jusqu&apos;au {formatDate(m.homework.list.end)}
      </MDTypography>
    </>
  );

  return (
    <Dialog open={!!homework.milestoneValidation} onClose={onCancel} maxWidth="md" fullWidth>
      {m === null && (
        <DialogContent sx={{ textAlign: "center" }}>
          <CircularProgress color="info" />
        </DialogContent>
      )}
      {!!m && !m.id && (
        <DialogContent sx={{ textAlign: "center" }}>
          <MDTypography sx={{ mb: 1.5 }} color="text">
            Étape invalide.
          </MDTypography>
        </DialogContent>
      )}
      {!!m && m.id && (
        <AlreadyValidated m={m} onCancel={onCancel} title={title}>
          <ValidationComponent
            {...(m.validation_params || {})}
            m={m}
            from={homework.milestoneValidationFrom}
            onCancel={onCancel}
            title={title}
          />
        </AlreadyValidated>
      )}
      <IconButton
        aria-label="close"
        onClick={onCancel}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}

export default MilestoneValidationDialog;
